import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Caption } from '../FontStyles';
import Button from '../elements/Button';
import tidepoolT from '../../images/tidepool-t-copy.svg';
import Subnav from '../elements/Subnav';
import NotificationsPanel from '../elements/NotificationsPanel';
import baseTheme from '../../themes/baseTheme';
import NavListItem from '../elements/NavListItem';
import { Avatar, Popover, Position, Pane } from 'evergreen-ui';

const HeaderCont = Styled(Flex)`
border-bottom: ${baseTheme.border};
height: 60px;
width: 100%;
background-color: ${baseTheme.colors.white};
position: fixed;
align-items: center;
justify-content: space-between
top: 0;
z-index: 9999999999999;
left: 0;

& .avatar-arrow{
  font-size: 20px;
}
img {
  max-height: 50px;
}

i {
  font-size: 32px;
  color: ${baseTheme.colors.primaryFont};
}
`;

const TheHr = Styled(Flex)`
height: 1px;
width: 100%;
border-top: ${baseTheme.border};
`;

const AcctSection = Styled(NavListItem)`
border-top: 1px solid black !important;

`;

const HeaderBody1 = Styled(Flex)`
margin: 0;
text-align: center;
`;

const HeaderAvatar = Styled(Avatar)`
background-color: ${baseTheme.colors.mediumPurple} !important;
opacity: 1;
margin-right: 0px;

&:hover {
  cursor: pointer;
}

& span {
  color: ${baseTheme.colors.white} !important;
}
`;

class Header extends React.Component {
  render() {
    return (
      <div>
        <HeaderCont>
          <Flex width={1} alignItems="center" justifyContent="space-between">
            <Flex alignItems="center" width={0.33} px={4}>
              <Link to="/">
                <img alt="Tidepool T" src={tidepoolT} />
              </Link>
              <Flex ml={3}>
                <Caption> For Providers </Caption>
              </Flex>
            </Flex>
            <Flex width={0.33} flexWrap="wrap" textAlign="center" justifyContent="center">
              <HeaderBody1 m={0} color="white">
                {this.props.patientName ? this.props.patientName : 'Jill Jellyfish'}
              </HeaderBody1>
            </Flex>
            <Flex width={0.33} justifyContent="flex-end" alignItems="center">
              <Popover bringFocusInside content={<NotificationsPanel />} position={Position.TOP_RIGHT}>
                <Pane style={{ cursor: 'pointer' }}>
                  <Flex mr={3}>
                    <i class="material-icons">notifications</i>
                  </Flex>
                </Pane>
              </Popover>
              <Flex px={3}>
                <Popover
                  bringFocusInside
                  minWidth={100}
                  content={
                    <Pane maxWidth={400}>
                      <Flex width={1} flexWrap="wrap">
                        <NavListItem to="/patients" width={1}>
                          Patient list
                        </NavListItem>
                        <NavListItem width={1}>Edit settings</NavListItem>
                        <NavListItem maxWidth={1}>Followers</NavListItem>
                        <Flex width={1}>
                          <TheHr />
                        </Flex>
                        <AcctSection width={1}>
                          <Flex justifyContent="space-between" alignItems="center">
                            <Caption> Logged in as: Dr. Seastar </Caption>
                            <Button> Log Out </Button>
                          </Flex>
                        </AcctSection>
                      </Flex>
                    </Pane>
                  }
                >
                  <Pane style={{ cursor: 'pointer' }}>
                    <Flex alignItems="center">
                      <HeaderAvatar solid name="Dr. Seastar" size={32} />
                      <i class="material-icons avatar-arrow">expand_more</i>
                    </Flex>
                  </Pane>
                </Popover>
              </Flex>
            </Flex>
          </Flex>
        </HeaderCont>
        <Subnav data={this.props.data} navShown={this.props.navShown} />
      </div>
    );
  }
}

export default Header;
